import React, { useEffect, useState } from 'react'
import { QRCodeSVG } from 'qrcode.react'
import { Box, Box as Wrapper } from '@node-space/ui-components'

export type QRCodeProps = {
  displayAddress: string
  selectedCurrencyCode: string
  protocol: string
  size?: number
  isLoading?: boolean
  isMultiProtocolCurrency: boolean
}

export const QRCode = ({
  displayAddress,
  selectedCurrencyCode,
  protocol,
  size = 130,
  isLoading = false,
  isMultiProtocolCurrency,
}: QRCodeProps) => {
  let currencyIcon

  if ((selectedCurrencyCode === protocol && !isMultiProtocolCurrency) || !protocol) {
    currencyIcon = `${selectedCurrencyCode}`
  } else {
    currencyIcon = `${selectedCurrencyCode}-${protocol}`
  }

  const [isMounted, setMount] = useState(false)

  useEffect(() => {
    setMount(true)
  }, [])

  return (
    <>
      {isLoading || !isMounted ? (
        <Wrapper className="animate-pulse">
          <Box className="h-28 w-32 bg-gray-04 sm:h-32" />
        </Wrapper>
      ) : (
        <QRCodeSVG
          value={displayAddress}
          size={size}
          bgColor={'#ffffff'}
          fgColor={'#161E28'}
          level={'L'}
          includeMargin={false}
          imageSettings={{
            src: `${process.env.ICONS_URL}${currencyIcon}-border.svg`,
            x: undefined,
            y: undefined,
            height: 40,
            width: 40,
            excavate: false,
          }}
        />
      )}
    </>
  )
}
